// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Backdrop from '@material-ui/core/Backdrop/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

export function BackdropComponent({ open }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open} invisible={false}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
